// extracted by mini-css-extract-plugin
module.exports = {"anchor":"style_anchor__2zsnV","title":"style_title__3hkZr","inlineBlock":"style_inlineBlock__3zJ72","redBackgroundColor":"style_redBackgroundColor__s1Svb"};